import { useEffect, useState } from 'react';
import {Row, Col, Form} from 'react-bootstrap';
import {useLocation} from 'react-router-dom';
import DashboardTabs from '../components/iminio_comps/DashboardTabs';
import DashboardUserButton from '../components/iminio_comps/DashboardUserButton'
import { iminioBackend } from '../api/iminio_provider';
import IminioDataList from '../components/lists/IminioDataList';
import CreateUserForm from '../components/forms/CreateUserForm'
import CreateAdminForm from '../components/forms/CreateAdminForm'
import CreateCondominiumForm from '../components/forms/CreateCondominumForm'
import CreateInterventionForm from '../components/forms/CreateInterventionForm'
import ProfileForm from '../components/forms/ProfileForm';

function DashboardView({ props }) {

    const [isLoading, setIsLoading] = useState(true)
    const [userInfo, setUserInfo] = useState({})
    const [userFullname, setUserFullname] = useState('')
    const [currentView, setCurrentView] = useState(null);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
      const updateWindowDimensions = () => {
        const newWidth = window.innerWidth;
        setWindowWidth(newWidth);
      };
      window.addEventListener("resize", updateWindowDimensions);
      return () => window.removeEventListener("resize", updateWindowDimensions) 
    }, []);

    const currentRoute = useLocation()
    if (currentRoute.pathname.startsWith('/dashboard'))
        require('../styles/Dashboard.css')

    useEffect(()=>{
        const getUserInfo = async () => {
            if(Object.keys(userInfo).length > 0) return
            if(isLoading===false) return
            await iminioBackend.me().then(response=>{
                setUserInfo(response.me)
                setUserFullname(`${response.me.first_name} ${response.me.last_name}`)
            }).catch(e=>console.log(e))
            setIsLoading(false)
        }
        getUserInfo()
    }, [])

    useEffect(()=>{
        const lastView = window.location.hash.replace('#','')
        if(userInfo.group==='admin')
            if(lastView) setCurrentView(lastView)
            else setCurrentView('user')
        else if(userInfo.group==='technician')
            setCurrentView('technical_intervention')
        // window.location.hash = ""
    }, [userInfo])

    const updateName = (data) => {
        setUserInfo(data)
        setUserFullname(`${data.first_name} ${data.last_name}`)
    }
    
    return  (
        <>
            {isLoading === true ? '' : 
                <>
                    <Row id="dashboard-view-topbar-container" className="bg-gray width-100 align-items-center justify-content-end pr-5">
                        <Col xs={3} sm={3} md={windowWidth<1500 ? (windowWidth > 900? 12 : 9) : 8} lg={windowWidth<1500 ? 8 : 7}>
                            <Row id="dashboard-view-topbar-left-container" className="width-100">
                                <DashboardTabs userGroup={userInfo?.group} currentView={currentView} changeView={setCurrentView}/>
                            </Row>
                        </Col>
                        <Col xs={9} md={windowWidth<1500 ? 3 : 4} lg={windowWidth<1500 ? 4 : 5}>
                            <Row id="dashboard-view-topbar-right-container" className="align-items-center justify-content-end">
                                <i className="mdi mdi-help-circle-outline text-16 fg-orange me-2"></i>
                                <DashboardUserButton userFullname={userFullname} changeView={setCurrentView} />
                            </Row>
                        </Col>
                    </Row>
                    <Row id="dashboard-view-main-container" className={`mt-2 ${windowWidth>900?'px-4':''}`}>
                        <Col className="iminio-dashboard-container">
                            {currentView !== 'profile-form' ? '' : <ProfileForm userInfo={userInfo}  changeView={setCurrentView} onUpdateName={updateName}/>}
                            {currentView !== 'create-user-form' ? '' : <CreateUserForm changeView={setCurrentView}/>}
                            {currentView !== 'create-admin-form' ? '' : <CreateAdminForm changeView={setCurrentView}/>}
                            {currentView !== 'create-condominium-form' ? '' : <CreateCondominiumForm changeView={setCurrentView}/>}
                            {currentView !== 'create-intervention-form' ? '' : <CreateInterventionForm userGroup={userInfo?.group} changeView={setCurrentView}/>}
                            {['user', 'condominium', 'admin', 'technical_intervention'].includes(currentView) ? <IminioDataList userGroup={userInfo?.group} userId={userInfo?.id} modelName={currentView} changeView={setCurrentView} /> : ''}
                        </Col>
                    </Row>
                </>
            }
        </>
    )
}

export default DashboardView